import React from 'react';
import HeroSlider from './HeroSlider';
import BrandsGrid from './BrandsGrid';
import ProductsGrid from './ProductsGrid';
import BannerSection from './BannerSection';
import CategoriesGrid from './CategoriesGrid';
import CollectionsSection from './CollectionsSection';

const DynamicSection = ({ section, isLoading }) => {
  const type = section?.type;
  const sectionCode = section?.code;

  if (isLoading) {
    // Return skeleton based on section type
    switch (type) {
      case 'hero':
        return <HeroSlider section={null} isLoading={true} />;
      case 'brands':
        return <BrandsGrid section={null} isLoading={true} />;
      case 'products':
        return <ProductsGrid section={null} isLoading={true} />;
      case 'categories':
        return <CategoriesGrid section={null} isLoading={true} />;
      case 'collections':
        return <CollectionsSection section={null} isLoading={true} />;
      case 'banners':
      case 'banner':
        return <BannerSection section={null} isLoading={true} />;
      default:
        // Fallback to sectionCode for backward compatibility
        if (sectionCode === 'hero-slider' || sectionCode === 'hero_slider') return <HeroSlider section={null} isLoading={true} />;
        return null;
    }
  }

  if (!section || (!type && !sectionCode)) return null;

  // Render the appropriate component based on section type
  switch (type) {
    case 'hero':
      return <HeroSlider section={section} isLoading={false} />;
    case 'brands':
      const brands = section.items?.map(item => ({
        ...item.brand,
        title: item.brand?.name || item.title,
        image: item.brand?.logo || item.image,
        link_url: item.link_url,
        id: item.id
      })) || [];
      return <BrandsGrid section={{ ...section, items: brands }} isLoading={false} />;
    case 'products':
      const products = section.items?.map(item => ({
        ...item.product,
        link_url: item.link_url,
        gridKey: `${item.id}-${item.product?.id || item.item_id}`
      })) || [];
      return <ProductsGrid section={{ ...section, items: products.map(p => ({ ...p, id: p.gridKey })) }} isLoading={false} />;
    case 'categories':
      return <CategoriesGrid section={section} isLoading={false} />;
    case 'banners':
    case 'banner':
      return <BannerSection section={section} isLoading={false} />;
    case 'collections':
      return <CollectionsSection section={section} isLoading={false} />;
    case 'html':
      // Temporary: Render as a content section if needed
      return null;
    default:
      // Fallback to sectionCode mapping
      switch (sectionCode) {
        case 'hero-slider':
        case 'hero_slider':
          return <HeroSlider section={section} isLoading={false} />;
        case 'shop-by-brand':
        case 'shop_by_brand':
        case 'brands':
          return <BrandsGrid section={section} isLoading={false} />;
        case 'featured-products':
        case 'featured_products':
        case 'new-arrivals':
        case 'new_arrivals':
        case 'products':
          return <ProductsGrid section={section} isLoading={false} />;
        case 'special-promotion':
        case 'special_promotion':
          return <BannerSection section={section} isLoading={false} />;
        default:
          console.warn(`Unknown section type/code: ${type}/${sectionCode}`);
          return null;
      }
  }
};

export default DynamicSection;
